import React, { useState } from 'react';

const faqs = [
  {
    q: 'How far in advance should I book?',
    a: 'For weddings, 4–8 months is ideal. For portrait and equine sessions, 2–4 weeks is usually enough depending on season and weather.'
  },
  {
    q: 'What is required to secure my date?',
    a: 'A signed agreement and retainer are required to reserve your session date.'
  },
  {
    q: 'What if weather is bad on session day?',
    a: 'Outdoor sessions can be rescheduled to the next available date that works for both parties.'
  },
  {
    q: 'How long until I receive my photos?',
    a: 'Turnaround estimates are listed in each package. You’ll receive a gallery link when your photos are ready.'
  },
  {
    q: 'Do you travel outside Lexington?',
    a: 'Yes. Travel is available throughout Kentucky and nearby areas. Travel mileage above a 50-mile radius is $60.'
  }
];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.a
    }
  }))
};

export const FaqSection = () => {
  const [openQuestion, setOpenQuestion] = useState(null);

  return React.createElement(
    'section',
    {
      id: 'faq',
      className: 'scroll-mt-24 py-20 md:py-24 bg-white'
    },
    React.createElement('script', {
      type: 'application/ld+json',
      dangerouslySetInnerHTML: { __html: JSON.stringify(faqSchema) }
    }),
    React.createElement(
      'div',
      {
        className: 'max-w-5xl mx-auto px-4 sm:px-6 lg:px-8'
      },
      React.createElement(
        'h2',
        {
          className: 'text-4xl font-bold text-center mb-4'
        },
        'Frequently Asked Questions'
      ),
      React.createElement(
        'p',
        {
          className: 'text-gray-600 text-center mb-12 text-lg leading-relaxed'
        },
        'Quick answers to the most common booking questions.'
      ),
      React.createElement(
        'div',
        {
          className: 'space-y-4'
        },
        faqs.map((item, index) => {
          const slug = item.q
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)/g, '');
          const questionId = `faq-question-${slug}`;
          const answerId = `faq-answer-${slug}`;
          const isOpen = openQuestion === index;

          return React.createElement(
            'details',
            {
              key: item.q,
              open: isOpen,
              onToggle: (event) => {
                if (event.target.open) {
                  setOpenQuestion(index);
                } else if (openQuestion === index) {
                  setOpenQuestion(null);
                }
              },
              className: 'group rounded-xl border border-slate-200 bg-slate-50 px-5 py-4'
            },
            React.createElement(
              'summary',
              {
                id: questionId,
                className:
                  'flex cursor-pointer list-none items-start justify-between gap-4 rounded-md font-semibold text-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50'
              },
              React.createElement('span', null, item.q),
              React.createElement(
                'span',
                {
                  'aria-hidden': 'true',
                  className: 'text-xl leading-none text-teal-700'
                },
                isOpen ? '−' : '+'
              )
            ),
            React.createElement(
              'p',
              {
                id: answerId,
                role: 'region',
                'aria-labelledby': questionId,
                className: 'mt-3 text-gray-600 leading-relaxed'
              },
              item.a
            )
          );
        })
      )
    )
  );
};
